import { Transform, Type } from "class-transformer";
import { ArrayMinSize, IsArray, IsIn, IsNotEmpty, IsNumber, ValidateNested } from "class-validator";
import { IProductVariation, ITag, IPack, ICustomer } from "../../interfaces";
import { PromotionConditionType, PromotionConditionOperator } from "../../interfaces";
import { MongodbRelationId, TypeORMRelationId } from "../utils.dto";

/**
 * Anniversaire
 */
export class PromotionConditionBirthdayWindowDetailsDTO {
  @IsIn([PromotionConditionType.BIRTHDAY_WINDOW], { message: 'Le type de condition est requis' })
  type: PromotionConditionType.BIRTHDAY_WINDOW;

  @ValidateNested({ message: 'La configuration de la condition est invalide' })
  @Type(() => BirthdayWindowDetailsDTO)
  details: Record<string, any>;
}
class BirthdayWindowDetailsDTO {
  @IsNotEmpty({ message: 'Le nombre de jours avant la date de naissance est requis' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'Le nombre de jours avant la date de naissance est invalide' })
  daysBeforeBirthday: number;

  @IsNotEmpty({ message: 'Le nombre de jours après la date de naissance est requis' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'Le nombre de jours après la date de naissance est invalide' })
  daysAfterBirthday: number;
}

/**
 * Clients
 */
export class PromotionConditionCustomersDetailsDTO {
  @IsIn([PromotionConditionType.CUSTOMERS], { message: 'Le type de condition est requis' })
  type: PromotionConditionType.CUSTOMERS;

  @ValidateNested({ message: 'La configuration de la condition est invalide' })
  @Type(() => CustomersDetailsDTO)
  details: Record<string, any>;
}

class CustomersDetailsDTO {
  @IsIn([PromotionConditionOperator.IN, PromotionConditionOperator.NOT_IN], { message: 'L\'opérateur est requis' })
  operator: PromotionConditionOperator.IN | PromotionConditionOperator.NOT_IN;

  @IsArray({ message: 'La valeur est requise' })
  @ArrayMinSize(1, { message: 'Au moins un client est requis' })
  @Type(() => MongodbRelationId)
  value: ICustomer[];
}

/**
 * Packs
 */
export class PromotionConditionPacksDetailsDTO {
  @IsIn([PromotionConditionType.PACKS], { message: 'Le type de condition est requis' })
  type: PromotionConditionType.PACKS;

  @ValidateNested({ message: 'La configuration de la condition est invalide' })
  @Type(() => PacksDetailsDTO)
  details: Record<string, any>;
}

class PacksDetailsDTO {
  @IsIn([PromotionConditionOperator.IN, PromotionConditionOperator.NOT_IN], { message: 'L\'opérateur est requis' })
  operator: PromotionConditionOperator.IN | PromotionConditionOperator.NOT_IN;

  @ValidateNested({
    each: true,
    message: 'La valeur est requise'
  })
  @IsArray({ message: 'La valeur est requise' })
  @ArrayMinSize(1, { message: 'Au moins un pack est requis' })
  @Type(() => TypeORMRelationId)
  value: IPack[];

  @IsNotEmpty({ message: 'La quantité est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La quantité est invalide' })
  quantity: number;
}

/**
 * Produits
 */
export class PromotionConditionProductVariationsDetailsDTO {
  @IsIn([PromotionConditionType.PRODUCT_VARIATIONS], { message: 'Le type de condition est requis' })
  type: PromotionConditionType.PRODUCT_VARIATIONS;

  @ValidateNested({ message: 'La configuration de la condition est invalide' })
  @Type(() => ProductVariationsDetailsDTO)
  details: Record<string, any>;
}

class ProductVariationsDetailsDTO {
  @IsIn([PromotionConditionOperator.IN, PromotionConditionOperator.NOT_IN], { message: 'L\'opérateur est requis' })
  operator: PromotionConditionOperator.IN | PromotionConditionOperator.NOT_IN;

  @ValidateNested({
    each: true,
    message: 'La valeur est requise'
  })
  @IsArray({ message: 'La valeur est requise' })
  @ArrayMinSize(1, { message: 'Au moins un produit est requis' })
  @Type(() => TypeORMRelationId)
  value: IProductVariation[];

  @IsNotEmpty({ message: 'La quantité est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La quantité est invalide' })
  quantity: number;
}


/**
 * Tags
 */
export class PromotionConditionTagsDetailsDTO {
  // @IsIn([PromotionConditionType.TAGS], { message: 'Le type de condition est requis' })
  // type: PromotionConditionType.TAGS;

  // @ValidateNested({ message: 'La configuration de la condition est invalide' })
  // @Type(() => TagsDetailsDTO)
  // details: Record<string, any>;
}

class TagsDetailsDTO {
  @IsIn([PromotionConditionOperator.IN, PromotionConditionOperator.NOT_IN], { message: 'L\'opérateur est requis' })
  operator: PromotionConditionOperator.IN | PromotionConditionOperator.NOT_IN;

  @ValidateNested({
    each: true,
    message: 'La valeur est requise'
  })
  @IsArray({ message: 'La valeur est requise' })
  @ArrayMinSize(1, { message: 'Au moins un tag est requis' })
  @Type(() => TypeORMRelationId)
  value: ITag[];

  @IsNotEmpty({ message: 'La quantité est requise' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'La quantité est invalide' })
  quantity: number;
}

/**
 * Montant minimum de la commande
 */
export class PromotionConditionMinOrderTotalDetailsDTO {
  @IsIn([PromotionConditionType.ORDER_TOTAL], { message: 'Le type de condition est requis' })
  type: PromotionConditionType.ORDER_TOTAL;

  @ValidateNested({ message: 'La configuration de la condition est invalide' })
  @Type(() => MinOrderTotalDetailsDTO)
  details: Record<string, any>;
}

class MinOrderTotalDetailsDTO {
  @IsNotEmpty({ message: 'Le montant minimum de la commande est requis' })
  @Transform((value) => Number(value))
  @IsNumber({}, { message: 'Le montant minimum de la commande est invalide' })
  value: number;
}

export class PromotionConditionDTO {
  @IsIn(Object.values(PromotionConditionType), { message: 'Le type de condition est requis' })
  type: PromotionConditionType;

  @IsNotEmpty({ message: 'L\'identifiant de la condition est requis' })
  referenceId: string;
}
